/**
 * Local **proofreading** when no AI HTTP endpoint is configured.
 * Reply **suggestions** are implemented in {@link ./aiSuggestReplies.js}.
 */

const TYPO_MAP = [
  [/\bteh\b/gi, "the"],
  [/\bhte\b/gi, "the"],
  [/\brecieve\b/gi, "receive"],
  [/\brecieved\b/gi, "received"],
  [/\boccured\b/gi, "occurred"],
  [/\bseperate\b/gi, "separate"],
  [/\bdefinately\b/gi, "definitely"],
  [/\bwich\b/gi, "which"],
];

/**
 * @param {string} text
 */
export function lightProofreadEnglish(text) {
  if (!text || typeof text !== "string") return text;
  const normalized = text.replace(/\r\n/g, "\n");
  return normalized
    .split("\n")
    .map((line) => {
      let l = line.replace(/[ \t]+/g, " ");
      l = l.replace(/\bi\b/g, "I");
      for (const [re, rep] of TYPO_MAP) {
        l = l.replace(re, rep);
      }
      const m = l.match(/^(\s*)(.*)$/);
      const pad = m?.[1] ?? "";
      let body = m?.[2] ?? l;
      if (body.length && /^[a-z]/.test(body)) {
        body = body[0].toUpperCase() + body.slice(1);
      }
      return pad + body;
    })
    .join("\n")
    .trimEnd();
}
